<template>
  <RfSelect
    :modelValue="hhmm?.[0]"
    :items="hhItems"
    :disabled="disabled"
    variant="outlined"
    class="hh-select flex-1"
    itemKey="title"
    itemValue="value"
    v-bind="$attrs"
    autoWidth
    sameWidth
    @update:modelValue="updateHH"
  />
  <RfSelect
    :modelValue="hhmm?.[1]"
    :items="mmItems"
    :disabled="disabled"
    variant="outlined"
    class="mm-select flex-1"
    itemKey="title"
    itemValue="value"
    v-bind="$attrs"
    autoWidth
    sameWidth
    @update:modelValue="updateMM"
  />
</template>

<script setup>
import { computed } from "vue";
import RfSelect from "./inputs/RfSelect.vue";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  modelValue: { type: String, default: "00:00" },
  disabled: { type: Boolean, default: false },
  interval: { type: Number, default: 1 },
});

const emit = defineEmits(["update:modelValue"]);

const pad = value => String(value).padStart(2, "0");

const hhItems = Array.from({ length: 24 }, (_, i) => ({
  value: i,
  title: pad(i),
}));
const mmItems = computed(() => {
  const items = Array.from({ length: Math.ceil(60 / props.interval) }, (_, i) => {
    const value = i * props.interval;
    return { value, title: pad(value) };
  });
  if (props.interval !== 1) items.push({ value: 59, title: "59" });
  return items;
});

const hhmm = computed(() => props.modelValue?.split(":")?.map(Number));

const updateHH = h => emit("update:modelValue", `${pad(h)}:${pad(hhmm.value[1])}`);
const updateMM = m => emit("update:modelValue", `${pad(hhmm.value[0])}:${pad(m)}`);
</script>

<style scoped>
.hh-select :deep(.v-field) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.mm-select :deep(.v-field) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: -1px;
}
</style>
